<template>
    <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        focusable="false"
        shape-rendering="geometricPrecision"
    >
        <path
            clip-rule="evenodd"
            d="M23 12c0 6.076-4.925 11-11 11S1 18.076 1 12 5.925 1 12 1s11 4.924 11 11Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="square"
            stroke-linejoin="round"
        ></path>
        <path
            d="M12 18v-7"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        ></path>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
            fill="currentColor"
        ></path>
    </svg>
</template>

<script>
export default {
    name: 'InfoIcon'
};
</script>
